/**
 * string camel2Underline
 * @param camel camel case
 * @returns underline case
 */
export function camel2UnderScore(camel) {
    if (camel.length < 1) {
        return camel;
    }
    var result = camel[0].toLowerCase() + camel.substr(1);
    return result.replace(/([A-Z])/g, function ($1) { return "_".concat($1.toLowerCase()); });
}
/**
 * string underline2Camel
 * @param underline underline case
 * @returns camel case
 */
export function underScore2Camel(underline) {
    var array = underline.split('_');
    var result = '';
    for (var i = 0; i < array.length; i++) {
        var temp = array[i];
        if (temp.length > 0) {
            if (i === 0) {
                result += temp;
            }
            else {
                temp = "".concat(temp[0].toUpperCase()).concat(temp.substring(1));
                result += temp;
            }
        }
    }
    return result;
}
